export function Footer() {
  return (
    <footer className="border-t bg-card px-8 py-6">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="flex items-center gap-6 text-muted-foreground">
          <span className="text-primary">Crisis Hotline: 988</span>
          <span>•</span>
          <span>Available 24/7</span>
        </div>
        <div className="flex items-center gap-4 text-muted-foreground">
          <button className="transition-colors hover:text-primary">
            Privacy Policy
          </button>
          <button className="transition-colors hover:text-primary">
            Terms of Service
          </button>
          <button className="transition-colors hover:text-primary">
            Support
          </button>
        </div>
      </div>
      <div className="mt-4 border-t pt-4 text-center text-muted-foreground">
        <p>
          Remember: This AI assistant is not a replacement for professional
          mental health care. If you're experiencing a crisis, please contact
          emergency services or a mental health professional immediately.
        </p>
      </div>
    </footer>
  );
}
